
import { useLoading } from "@/contexts/LoadingContext";
import { LoadingOverlay } from "./loading-overlay";
import { PageLoadingOverlay } from "./page-loading-overlay";

export const LoadingOverlays = () => {
  const { 
    isPageLoading, 
    pageLoadingMessage, 
    isFileUploading, 
    fileUploadProgress, 
    fileUploadMessage 
  } = useLoading();

  return (
    <>
      <PageLoadingOverlay 
        isVisible={isPageLoading} 
        message={pageLoadingMessage} 
      />
      <LoadingOverlay
        isVisible={isFileUploading}
        title="Processing File"
        message={fileUploadMessage}
        progress={fileUploadProgress}
      />
    </>
  );
};
